/*
Error: test
  at blah (code:4:8)
  at code:7:0
*/
export function getRowAndColumn(stack) {
    let row = Number.NaN;
    let column = Number.NaN;
    const lines = stack.split("\n");
    for (const line of lines) {
        if (line.startsWith("  at ")) {
            const firstColonIndex = line.indexOf(":");
            if (firstColonIndex >= 0) {
                const secondColonIndex = line.indexOf(":", firstColonIndex + 1);
                if (secondColonIndex >= 0) {
                    row = parseInt(line.slice(firstColonIndex + 1, secondColonIndex));
                    column = parseInt(line.slice(secondColonIndex + 1));
                    break;
                }
            }
        }
    }
    return { row: row - 1, column: column - 1 };
}
